module.exports = __webpack_public_path__ + "static/media/cluster25.a0bee9bc.svg";